import { render, staticRenderFns } from "./Bin.vue?vue&type=template&id=26475d56"
import script from "./Bin.vue?vue&type=script&lang=js"
export * from "./Bin.vue?vue&type=script&lang=js"
import style0 from "./Bin.vue?vue&type=style&index=0&id=26475d56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports